'use strict'

initV1 = require './grpn-lazyload'
initV2 = require './grpn-lazyload-v2'

setupLazyloader = ->
  triggerClass = '.lazy-load'
  useV1 = true

  Finch.experiment 'LS-3902-Lazyloader-V2', {
    Treatment: -> useV1 = false
  }

  if useV1
    initV1.init()

    Groupon.Utils.lazyLoadImages = (options, customClass) ->
      customClass ?= triggerClass
      if ($el = $(customClass)).length
        $el.lazyload(options)
  else
    loader = initV2.init()
    Groupon.Utils.lazyLoadImages = (options, customClass) ->
      if customClass
        if typeof customClass is 'string'
          trigger = customClass ? triggerClass
        else
          # jquery object
          if typeof customClass is 'object' and customClass.hasOwnProperty('selector') and customClass.hasOwnProperty('context') and customClass.hasOwnProperty('length')
            return unless customClass.length
            trigger = customClass.selector or triggerClass
      else
        trigger = triggerClass

      if trigger
        loader(trigger, options)

module.exports = setupLazyloader()



// WEBPACK FOOTER //
// ./src/frontend/lazyload/lazyLoadImages.coffee